module.exports = __webpack_public_path__ + "static/media/croppedwhite.ee8ec446.png";